<template>
  <div>
    <Button class="next-btn" type="primary" @click="createInvoice"
      >开发票</Button
    >
    <div class="space">
      <h3>发票说明</h3>
      <p v-for="(item, index) in noticeList">{{ index + 1 }}、{{ item }}</p>
      <!--    <p></p>-->
      <!--    <p></p>-->
      <!--    <p>pc端线上电子发票功能正在实施中，请耐心等候</p>-->
      <!--    <p>当前开发票渠道：</p>-->
      <!--    <p>一、在颐和园官方微信公众号中，找到订单购票记录并申请开电子发票</p>-->
      <!--    <p>二、凭已使用的电子票记录，到公园售票处兑换发票，仅可兑换一次，且一经兑换遗失不补；</p>-->
    </div>
    <div class="space">
      <div class="header-title-Invoice">
        <div>
          <h3>开票设置</h3>
        </div>
        <div>
          <Button @click="add" type="primary">添加</Button>
        </div>
      </div>
      <Table
        :columns="columns1"
        :data="data1"
        :loading="listLoading"
        style="margin-top:10px"
      ></Table>
    </div>
    <div class="space">
      <h3>开票历史</h3>
      <Table
        :columns="columns2"
        :data="data2"
        :loading="historyLoading"
      ></Table>
      <div style="text-align: center">
        <Button
          @click="pageChange"
          v-if="showMore"
          class="show-more-btn"
          type="text"
        >
          查看更多
          <Icon type="md-arrow-dropdown" />
        </Button>
        <Button
          @click="pageDel"
          v-if="showHidden"
          class="show-more-btn"
          type="text"
        >
          收起
          <Icon type="md-arrow-dropup" />
        </Button>
      </div>
      <!--    <Page :total="pageInfo.totalCount" @on-change="pageChange" :styles="{textAlign: 'right', marginTop: '20px'}"/>-->
    </div>
    <Modal v-model="deleteShow" width="360">
      <div style="text-align:center; padding-top: 16px;">
        <p>是否删除该条设置?</p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="remove"
          >删除</Button
        >
      </div>
    </Modal>

    <Modal
      v-model="addAndEditShow"
      :title="title"
      :closable="false"
      :mask-closable="false"
     >

       <div slot="footer" v-if="actionType == 'detail'">
          <Button type="error" size="large" @click="addAndEditCancel">关闭</Button>
      </div>

      <div slot="footer" v-else>
          <Button type="default" size="large" @click="addAndEditCancel">取消</Button>
          <Button type="error" size="large" :loading="editLoading" @click="addAndEditOk">保存</Button>
      </div>

        <Form ref="formValidate" :model="formValidate" :rules="ruleTable" :label-width="80" :disabled="actionType == 'detail'">
            <FormItem label="单位名称" prop="companyName">
                <Input v-model="formValidate.companyName" placeholder="请输入单位名称"></Input>
            </FormItem>
            <FormItem label="税号" prop="taxId">
                <Input v-model="formValidate.taxId" placeholder="请输入税号"></Input>
            </FormItem>
            <FormItem label="注册地址" prop="address">
                <Input v-model="formValidate.address" placeholder="请输入注册地址"></Input>
            </FormItem>
            <FormItem label="注册电话" prop="phone">
                <Input v-model="formValidate.phone" placeholder="请输入注册电话"></Input>
            </FormItem>
            <FormItem label="开户银行" prop="accountName">
                <Input v-model="formValidate.accountName" placeholder="请输入开户银行"></Input>
            </FormItem>
            <FormItem label="银行账号" prop="accountNo">
                <Input v-model="formValidate.accountNo" placeholder="请输入银行账号"></Input>
            </FormItem>
            
        </Form>
    </Modal>

    <Modal
      v-model="reApply1"
      title="申请重开发票须知"
      :closable="false"
      :mask-closable="false"
      width="600"
     >

     <p>1. 您提交的请求将由人工进行审核，人工审核的时间有可能较长。</p>
     <p>2. 审核通过后，原发票将作废无法报销，新的发票您可以在个人中心-我的发票里进行查看。</p>
     <p>3.一个发票仅可申请自助重开一次，请仔细核对您填写的发票信息，以防止不能再次修改。</p>
       <div slot="footer" style="display:flex;justify-content: center;">
        <Button type="primary"  @click="reApply1Submit">确认申请</Button>
        <Button type="error"  @click="reApply1Cancel">取消</Button>
      </div>

    </Modal>


    <Modal
      v-model="reApply2"
      title="重开发票确认"
      :closable="false"
      :mask-closable="false"
      width="600"
     >

      <Row class="row-margin">
        <Col span="24">
          <Button
            class="tab-btn"
            @click="checkType('personal')"
            v-if="tabShow"
            :type="btnType('personal')"
            >个人</Button
          >
          <Button
            class="tab-btn"
            @click="checkType('company')"
            :type="btnType('company')"
            >单位</Button
          >
        </Col>
      </Row>
      <Row class="row-margin" v-if="btnOn === 1">
        <Col span="24">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            inline
            :label-width="120"
          >
            <FormItem label="发票抬头" prop="companyName">
              <Select v-model="formInline.id" style="width: 180px">
                <Option
                  v-for="item in invoiceList"
                  :value="item.id"
                  :key="item.id"
                  >{{ item.companyName }}</Option
                >
              </Select>
              <!--          <Input type="text" v-model="formInline.companyName" placeholder="请输入单位名称"></Input>-->
            </FormItem>

            <FormItem label="接收邮箱" prop="receiveEmail">
             <Input type="text" v-model="formInline.receiveEmail" placeholder="请输入接收邮箱"></Input>
            </FormItem>

             <div style="font-weight:600" v-if="reApplyObj.row"> <FormItem label="开票金额">
               ￥{{reApplyObj.row.totalAmount}}
            </FormItem>
            </div>
          </Form>
        </Col>
      </Row>
      <Row class="row-margin" v-if="btnOn === 0">
      <Col span="24">
        <Form ref="formInline" :model="formInline" :rules="ruleInline" inline :label-width="120">
          <FormItem label="发票抬头" prop="companyName">
              <Input type="text" v-model="formInline.companyName" placeholder="请输入发票抬头"></Input>
          </FormItem>
          <FormItem label="接收邮箱" prop="receiveEmail">
             <Input type="text" v-model="formInline.receiveEmail" placeholder="请输入接收邮箱"></Input>
            </FormItem>
            <div style="font-weight:600" v-if="reApplyObj.row"> <FormItem label="开票金额">
               ￥{{reApplyObj.row.totalAmount}}
            </FormItem>
            </div>
        </Form>
      </Col>
    </Row>
       <div slot="footer" style="display:flex;justify-content: center;">
        <Button type="primary"  @click="reApply2Submit">确认</Button>
        <Button type="error"  @click="reApply2Cancel">取消</Button>
      </div>

    </Modal>
  </div>
</template>

<script>
import { isCompanyName, isTaxId, isAccountName, isAccountNo, isPhoneOrMobile} from "@/util/reg";
import { httpAction } from "@/api/manage";
import api from "@/api";
import common from "@/util/common";
export default {
  data() {
    const validateFun = (rule, value, callback) => {
      let errorStr = "";
      if (value.trim() === "") {
        if (rule.field === "companyName") {
          errorStr = "请填写单位名称";
        } else if (rule.field === "taxId") {
          errorStr = "请填写税号";
        } else {
          return callback();
        }
        return callback(new Error(errorStr));
      } else if (value.trim() !== "") {
        if (rule.field === "companyName") {
          if (!isCompanyName(value)) {
            errorStr = "请填写正确的单位名称!";
          } else {
            return callback();
          }
        } else if (rule.field === "taxId") {
          if (!isTaxId(value)) {
            errorStr = "请填写有效的税号!";
          } else {
            return callback();
          }
        }else if (rule.field === "phone") {
          if (!isPhoneOrMobile(value)) {
            errorStr = "注册电话格式不正确!";
          } else {
            return callback();
          }
        }else if (rule.field === "accountName") {
          if (!isAccountName(value)) {
            errorStr = "开户银行格式不正确!";
          } else {
            return callback();
          }
        }else if (rule.field === "accountNo") {
          if (!isAccountNo(value)) {
            errorStr = "银行卡号格式不正确!";
          } else {
            return callback();
          }
        } else {
          return callback();
        }
        return callback(new Error(errorStr));
      } else {
        return callback();
      }
    };
    return {
      // columns1: [
      //   {
      //     title: "序号",
      //     type: "index",
      //     width: 80,
      //     align: "center"
      //   },
      //   {
      //     title: "单位名称",
      //     key: "companyName",
      //     render: (h, params) => {
      //       if (params.row.editable) {
      //         return h("Input", {
      //           domProps: {
      //             value: params.row.companyName,
      //             type: "text",
      //             size: "small"
      //           },
      //           props: {
      //             value: params.row.companyName,
      //             placeholder: "请输入单位名称"
      //           },
      //           on: {
      //             input: val => {
      //               // this.tableForm.companyName = ''
      //               this.data1[params.index].companyName = val;
      //             }
      //           }
      //         });
      //       } else {
      //         return h("div", {}, params.row.companyName);
      //       }
      //     }
      //   },
      //   {
      //     title: "税号",
      //     key: "taxId",
      //     render: (h, params) => {
      //       if (params.row.editable) {
      //         return h("Input", {
      //           domProps: {
      //             value: params.row.taxId,
      //             type: "text",
      //             size: "small"
      //           },
      //           props: {
      //             value: params.row.taxId,
      //             placeholder: "请输入税号"
      //           },
      //           on: {
      //             input: val => {
      //               this.data1[params.index].taxId = val;
      //             }
      //           }
      //         });
      //       } else {
      //         return h("div", {}, params.row.taxId);
      //       }
      //     }
      //   },
      //   {
      //     title: "操作",
      //     slot: "action",
      //     align: "left",
      //     render: (h, params) => {
      //       if (params.row.editable) {
      //         return h("div", [
      //           h(
      //             "Button",
      //             {
      //               props: { type: "primary", size: "small" },
      //               style: { marginRight: "5px" },
      //               on: {
      //                 click: () => {
      //                   this.edit(params);
      //                 }
      //               }
      //             },
      //             "保存"
      //           ),
      //           h(
      //             "Button",
      //             {
      //               props: { size: "small" },
      //               on: {
      //                 click: () => {
      //                   this.tableCancel(params);
      //                 }
      //               }
      //             },
      //             "取消"
      //           )
      //         ]);
      //       } else {
      //         return h("div", [
      //           h(
      //             "Button",
      //             {
      //               props: { type: "primary", size: "small" },
      //               style: { marginRight: "5px" },
      //               on: {
      //                 click: () => {
      //                   this.toEdit(params);

      //                   // this.data1[params.index].editable = true
      //                 }
      //               }
      //             },
      //             "修改"
      //           ),
      //           h(
      //             "Button",
      //             {
      //               props: { type: "error", size: "small" },
      //               on: {
      //                 click: () => {
      //                   this.deleteShow = true;
      //                   this.currentItem = params;
      //                 }
      //               }
      //             },
      //             "删除"
      //           ),
      //           h(
      //             "Button",
      //             {
      //               style: {
      //                 marginLeft: "5px",
      //                 display:
      //                   params.row.isDefault === "1" ? "none" : "inline-block"
      //               },
      //               props: { type: "warning", size: "small" },
      //               on: {
      //                 click: () => {
      //                   this.actionType = "update";
      //                   const obj = params;
      //                   obj.row.isDefault = "1";
      //                   this.edit(obj);
      //                 }
      //               }
      //             },
      //             "设为默认"
      //           ),
      //           h(
      //             "Button",
      //             {
      //               style: {
      //                 marginLeft: "5px",
      //                 display:
      //                   params.row.isDefault === "1" ? "inline-block" : "none"
      //               },
      //               props: { size: "small" }
      //             },
      //             "默认"
      //           )
      //         ]);
      //       }
      //     }
      //   }
      // ],
      title: '',
      columns1: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center"
        },
        {
          title: "单位名称",
          key: "companyName",
        },
        {
          title: "税号",
          key: "taxId",
        },

        // {
        //   title: "注册地址",
        //   key: "address",
        //    width: 300,
        // },
        // {
        //   title: "注册电话",
        //   key: "phone",
        //    width: 300,
        // },
        // {
        //   title: "开户银行",
        //   key: "accountName",
        //    width: 300,
        // },
        // {
        //   title: "银行账号",
        //   key: "accountNo",
        //    width: 300,
        // },

        {
          title: "操作",
          slot: "action",
          align: "left",
          render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: { type: "primary", size: "small" },
                    style: { marginRight: "5px" },
                    on: {
                      click: () => {
                        this.toDetail(params);

                        // this.data1[params.index].editable = true
                      }
                    }
                  },
                  "详细"
                ),
                h(
                  "Button",
                  {
                    props: { type: "primary", size: "small" },
                    style: { marginRight: "5px" },
                    on: {
                      click: () => {
                        this.edit(params);

                        // this.data1[params.index].editable = true
                      }
                    }
                  },
                  "修改"
                ),
                h(
                  "Button",
                  {
                    props: { type: "error", size: "small" },
                    on: {
                      click: () => {
                        this.deleteShow = true;
                        this.currentItem = params;
                      }
                    }
                  },
                  "删除"
                ),
                h(
                  "Button",
                  {
                    style: {
                      marginLeft: "5px",
                      display:
                        params.row.isDefault === "1" ? "none" : "inline-block"
                    },
                    props: { type: "warning", size: "small" },
                    on: {
                      click: () => {
                        // this.actionType = "update";
                        const obj = params;
                        obj.row.isDefault = "1";
                        this.updateStatus(obj);
                      }
                    }
                  },
                  "设为默认"
                ),
                h(
                  "Button",
                  {
                    style: {
                      marginLeft: "5px",
                      display:
                        params.row.isDefault === "1" ? "inline-block" : "none"
                    },
                    props: { size: "small" }
                  },
                  "默认"
                )
              ])
          }
        }

        // {
        //   title: "操作",
        //   slot: "action",
        //   align: "left",
        //   render: (h, params) => {
        //     if (params.row.editable) {
        //       return h("div", [
        //         h(
        //           "Button",
        //           {
        //             props: { type: "primary", size: "small" },
        //             style: { marginRight: "5px" },
        //             on: {
        //               click: () => {
        //                 this.edit(params);
        //               }
        //             }
        //           },
        //           "保存"
        //         ),
        //         h(
        //           "Button",
        //           {
        //             props: { size: "small" },
        //             on: {
        //               click: () => {
        //                 this.tableCancel(params);
        //               }
        //             }
        //           },
        //           "取消"
        //         )
        //       ]);
        //     } else {
        //       return h("div", [
        //         h(
        //           "Button",
        //           {
        //             props: { type: "primary", size: "small" },
        //             style: { marginRight: "5px" },
        //             on: {
        //               click: () => {
        //                 this.toEdit(params);

        //                 // this.data1[params.index].editable = true
        //               }
        //             }
        //           },
        //           "修改"
        //         ),
        //         h(
        //           "Button",
        //           {
        //             props: { type: "error", size: "small" },
        //             on: {
        //               click: () => {
        //                 this.deleteShow = true;
        //                 this.currentItem = params;
        //               }
        //             }
        //           },
        //           "删除"
        //         ),
        //         h(
        //           "Button",
        //           {
        //             style: {
        //               marginLeft: "5px",
        //               display:
        //                 params.row.isDefault === "1" ? "none" : "inline-block"
        //             },
        //             props: { type: "warning", size: "small" },
        //             on: {
        //               click: () => {
        //                 this.actionType = "update";
        //                 const obj = params;
        //                 obj.row.isDefault = "1";
        //                 this.edit(obj);
        //               }
        //             }
        //           },
        //           "设为默认"
        //         ),
        //         h(
        //           "Button",
        //           {
        //             style: {
        //               marginLeft: "5px",
        //               display:
        //                 params.row.isDefault === "1" ? "inline-block" : "none"
        //             },
        //             props: { size: "small" }
        //           },
        //           "默认"
        //         )
        //       ]);
        //     }
        //   }
        // }
      ],
      columns2: [
        {
          title: "发票号",
          key: "fpHm",
          minWidth: 100
        },
        {
          title: "开票日期",
          key: "applyTime",
          minWidth: 180
        },
        {
          title: "发票金额",
          key: "totalAmount",
          minWidth: 80,
          render: (h, params) => {
            return h("span", {}, `¥${params.row.totalAmount}`);
          }
        },
        // {
        //   title: '发票',
        //   key: 'finishTime',
        //   minWidth: 200,
        //   render: (h, params) => {
        //     // console.log(params.row.spUrl)
        //     return h('img', {
        //       attrs: {
        //         src: params.row.pdfUrl
        //       },
        //       style: {
        //         width: '200px'
        //       }
        //     }, '')
        //   }
        // },
        {
          title: "操作",
          slot: "action",
          align: "left",
          width: 400,
          render: (h, params) => {
            let canReApply = params.row.canReApply == 'true'
            let canErrorApply = params.row.canErrorApply == 'true'
            let canDownloadXml = params.row.xmlUrl != ''
            let canDownloadOfd = params.row.ofdUrl != ''
            if (params.row.fpHm) {
              return h("div", [
                h(
                  "Button",
                  {
                    props: { type: "primary", size: "small" },
                    style: { marginRight: "5px" },
                    on: {
                      click: () => {
                        this.toDownload(params);
                      }
                    }
                  },
                  "下载PDF"
                ),
                canDownloadXml ? h(
                  "Button",
                  {
                    props: { type: "primary", size: "small" },
                    style: { marginRight: "5px" },
                    on: {
                      click: () => {
                        this.toDownloadXml(params);
                      }
                    },
                    // directives: [
                    //   {
                    //     name: 'v-if',
                    //     value: params.row.canReApply == 'true'
                    //   }
                    // ]
                  },
                  "下载XML"
                ) : "",
                canDownloadOfd ? h(
                  "Button",
                  {
                    props: { type: "primary", size: "small" },
                    style: { marginRight: "5px" },
                    on: {
                      click: () => {
                        this.toDownloadOfd(params);
                      }
                    },
                    // directives: [
                    //   {
                    //     name: 'v-if',
                    //     value: params.row.canReApply == 'true'
                    //   }
                    // ]
                  },
                  "下载OFD"
                ) : "",

                canReApply ? h(
                  "Button",
                  {
                    props: { type: "primary", size: "small" },
                    style: { marginRight: "5px" },
                    on: {
                      click: () => {
                        this.toReApplyInvoice(params);
                      }
                    },
                    // directives: [
                    //   {
                    //     name: 'v-if',
                    //     value: params.row.canReApply == 'true'
                    //   }
                    // ]
                  },
                  "重开申请"
                ) : "",
                // canErrorApply ? h(
                //   "Button",
                //   {
                //     props: { type: "primary", size: "small" },
                //     style: { marginRight: "5px" },
                //     on: {
                //       click: () => {
                //         this.toDownload(params);
                //       }
                //     },
                //     // directives: [
                //     //   {
                //     //     name: 'v-if',
                //     //     value: params.row.canErrorApply == 'true'
                //     //   }
                //     // ]
                //   },
                //   "再次提交"
                // ) : ""
              ]);
            } else {
              return h("span", {}, params.row.applyStatusName);
            }
          }
        }
      ],
      formInline: {
        companyName: "",
        id: ""
      },
      
      invoiceList: [],
      data1: [],
      data2: [
      ],
      formValidate: {
          companyName: '',
          taxId: '',
          address: '',
          phone: '',
          accountName: '',
          accountNo: '',
      },
      //  ruleValidate: {
      //       companyName: [
      //           { required: true, message: '单位名称不能为空', trigger: 'blur' },
      //           { validator: validateRegName, trigger: 'blur' }
      //       ],
      //       taxId: [
      //           { required: true, message: '税号不能为空', trigger: 'blur' }
      //       ]
      //   },
      // url: {
      //   list: '/yhy/openapi/web/invoice/list',
      //   create: '/yhy/openapi/web/invoice/create',
      //   update: '/yhy/openapi/web/invoice/update',
      //   delete: '/yhy/openapi/web/invoice/delete',
      //   history: '/yhy/openapi/web/invoice/apply/list'
      // },
      reApplyObj: {},
      btnOn: 0,
      actionType: "",
      tabShow: true,
      reApply2:false,
      reApply1:false,
      editLoading: false,
      addAndEditShow:false,
      listLoading: false,
      historyLoading: false,
      deleteShow: false,
      currentItem: {},
      modal_loading: false,
      pageInfo: {
        totalCount: 0
      },
      tableForm: {
        companyName: "",
        taxId: ""
      },
      ruleTable: {
        companyName: [{ validator: validateFun, trigger: "blur" }],
        taxId: [{ validator: validateFun, trigger: "blur" }],
        phone: [{ validator: validateFun, trigger: "blur" }],
        accountName: [{ validator: validateFun, trigger: "blur" }],
        accountNo: [{ validator: validateFun, trigger: "blur" }],
      },
      ruleInline: {
        companyName: [{ validator: validateFun, trigger: "blur" }],
        id: [{ validator: validateFun, trigger: "blur" }],
        receiveEmail: [
            { required: true, message: '接收邮箱不能为空', trigger: 'blur' },
             { type: 'email', message: '邮箱格式不正确', trigger: 'blur' }
        ],
      },
      pageNum: 1,
      showMore: true,
      showHidden: false,
      rowData: {},
      noticeList: []
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getList();
      vm.getHistory();
      vm.getNotice();
    });
  },
  mounted() {
    // this.getList()
    // this.getHistory()
    if (common.userType() === "1") {
      this.btnOn = 1;
      this.tabShow = false;
    }
  },
  methods: {
    async reApply2Submit() {

       this.$refs['formInline'].validate((valid) => {
        if(valid) {
          console.log(this.invoiceList)
          console.log(this.formInline)
          let selectTitle
          if(this.btnOn == 1) {
            selectTitle = this.invoiceList.filter(item=>item.id == this.formInline.id)
            if(selectTitle.length == 0) {
              this.$Message.warning("请选择发票抬头!");
              return
            }
          }
          const parameter = {
            id: this.reApplyObj.row.id,
            applyChannel: 'pc',
            orderType: this.reApplyObj.row.orderType,
            invoiceType: '3',
            invoiceHeader: this.btnOn == 1 ? 'company' : 'person',
            companyName: this.btnOn == 1 ? selectTitle[0].companyName : this.formInline.companyName,
            taxId: this.btnOn == 1 ? selectTitle[0].taxId : '',
            receiveEmail: this.formInline.receiveEmail,
            address: this.btnOn == 1 ? selectTitle[0].address : '',
            phone: this.btnOn == 1 ? selectTitle[0].phone : '',
            accountName:this.btnOn == 1 ? selectTitle[0].accountName : '',
            accountNo:this.btnOn == 1 ? selectTitle[0].accountNo : ''
          }
          console.log(parameter)
          //return
          httpAction(api.InvoiceReApply, 'post', parameter).then(res => {
            if (res.status == '0') {
              this.$Message.success("已提交,请耐心等待!");
              // this.getHistory()
               this.formInline =  {
                  companyName: "",
                  id: "",
                  receiveEmail: ""
                }
                this.getRefreshHistory()
            }else{
              this.$Message.error(res.errorMessage);
            }
          }).finally(()=>{
            // this.$refs['formValidate'].resetFields();
            // this.editLoading = false
            // this.addAndEditShow = false
            this.reApply2 = false
          })

        }
       })
      
    },
    btnType(type) {
      let btnType = null;
      if (type === "personal") {
        if (this.btnOn === 0) btnType = "primary";
      } else {
        if (this.btnOn === 1) btnType = "primary";
      }

      return btnType;
    },
    checkType(type) {
      if (common.userType() === "1") {
        this.btnOn = 1;
      } else {
        if (type === "personal") {
          this.btnOn = 0;
        } else {
          this.btnOn = 1;
        }
      }
    },
    reApply1Submit() {
      this.reApply1 = false
      this.reApply2 = true
    },
    reApply2Cancel() {
      this.reApply2 = false
       this.formInline =  {
          companyName: "",
          id: "",
          receiveEmail: ""
        }
    },
    reApply1Cancel(){
      this.reApply1 = false
    },
    toReApplyInvoice(params) {
      this.reApplyObj = params
      this.reApply1 = true
      this.getList()
    },
    updateStatus(params) {
      const obj = {
        companyName: params.row.companyName,
        taxId: params.row.taxId,
        address: params.row.address,
        phone: params.row.phone,
        accountName: params.row.accountName,
        accountNo: params.row.accountNo,
        isDefault: params.row.isDefault,
        type: params.row.type,
        invoiceId: params.row.id
      }
      let url = api.updateInvoice
      httpAction(url, 'post', obj).then(res => {
        if (res) {
          this.getList()
        }
      }).finally(()=>{
        // this.$refs['formValidate'].resetFields();
        // this.editLoading = false
        // this.addAndEditShow = false
      })
    },
    addAndEditOk() {
      console.log('123')
      this.$refs['formValidate'].validate((valid) => {
        console.log(valid)
            if (valid) {
              const obj = {
                companyName: this.formValidate.companyName,
                taxId: this.formValidate.taxId,
                address: this.formValidate.address,
                phone: this.formValidate.phone,
                accountName: this.formValidate.accountName,
                accountNo: this.formValidate.accountNo,
                isDefault: 0,
                type: 'company'
              }
              this.editLoading = true
                if (this.actionType === 'update') {
                  obj.invoiceId = this.formValidate.id
                }
              let url = this.actionType === 'update' ? api.updateInvoice : api.createInvoice
              httpAction(url, 'post', obj).then(res => {
                if (res) {
                  this.getList()
                }
              }).finally(()=>{
                this.$refs['formValidate'].resetFields();
                this.editLoading = false
                this.addAndEditShow = false
              })
            } else {
                return
            }
        })
    },
    addAndEditCancel() {
      this.$refs['formValidate'].resetFields();
      this.addAndEditShow = false
    },
    getNotice() {
      httpAction(api.getInvoiceNotice, "post").then(res => {
        if (res.status == 0) {
          this.noticeList = res.data;
        }
      });
    },
    tableCancel(params) {
      const data = params.row;
      if (this.actionType === "create") {
        this.data1.splice(params.index, 1);
      } else {
        this.$set(this.data1, params.index, this.rowData);
      }
      this.actionType = "";
    },
    createInvoice() {
      this.$router.push("/order/create-invoice");
    },
    toDownload(params) {
      let pdfUrl = params.row.pdfUrl;
      let fpHm = params.row.fpHm;
      if (fpHm) {
        let protocol = window.location.protocol;
        if (protocol === "https:") {
          let newpdfUrl = "";
          if (pdfUrl.startsWith("http://")) {
            newpdfUrl = pdfUrl.replace("http://", "https://");
          }else{
            newpdfUrl = pdfUrl
          }
          window.open(newpdfUrl);
        } else {
          window.open(pdfUrl);
        }
      }
    },
    toDownloadXml(params) {
      let xmlUrl = params.row.xmlUrl;
      let fpHm = params.row.fpHm;
      if (fpHm) {
        let protocol = window.location.protocol;
        if (protocol === "https:") {
          let newUrl = "";
          if (xmlUrl.startsWith("http://")) {
            newUrl = xmlUrl.replace("http://", "https://");
          }else{
            newUrl = xmlUrl
          }
          window.open(newUrl);
        } else {
          window.open(xmlUrl);
        }
      }
    },
    toDownloadOfd(params) {
      let ofdUrl = params.row.ofdUrl;
      let fpHm = params.row.fpHm;
      if (fpHm) {
        let protocol = window.location.protocol;
        if (protocol === "https:") {
          let newUrl = "";
          if (ofdUrl.startsWith("http://")) {
            newUrl = ofdUrl.replace("http://", "https://");
          }else{
            newUrl = ofdUrl
          }
          window.open(newUrl);
        } else {
          window.open(ofdUrl);
        }
      }
    },
    getList() {
      this.listLoading = true;
      httpAction(api.invoiceList, "post").then(res => {


        if (res.status == 0) {
          this.data1 = res.data;
          this.listLoading = false;
          this.invoiceList = res.data;

          console.log(this.invoiceList)
          let existDefault = false;
          // console.log(this.invoiceList)
          res.data.forEach(item => {
            if (item.isDefault == 1) {
              existDefault = true;
              this.formInline.companyName = item.companyName;
              this.formInline.id = item.id;
            }
          });
          console.log(this.invoiceList)
          console.log('----------------')

          if (this.invoiceList.length != 0 && !existDefault) {
            this.formInline.companyName = this.invoiceList[0].companyName;
            this.formInline.id = this.invoiceList[0].id;
          }
          if (common.userType() !== '1') {
            this.formInline.companyName = '个人'
          }
        }

      });
    },
    pageChange() {
      this.getHistory();
    },
    pageDel() {
      this.pageNum = 1;
      this.data2 = [];
      this.showMore = true;
      this.showHidden = false;
      this.getHistory();
    },
    getRefreshHistory() {
      this.pageNum = 1
      const obj = {
        orderType: this.common.userTypeStr(),
        pageNo: this.pageNum,
        perPageSize: 10
      };
      this.historyLoading = true;
      httpAction(api.historyInvoice, "post", obj).then(res => {
        this.data2 = res.data.infoList
        this.pageInfo.totalCount = res.data.totalCount * 1;
        this.historyLoading = false;
        if (res.data.infoList.length < 10) {
          this.showMore = false;
        } else {
          this.pageNum += 1;
        }
      });
    },
    getHistory() {
      const pageNum = this.pageNum;
      const obj = {
        orderType: this.common.userTypeStr(),
        pageNo: pageNum,
        perPageSize: 10
      };
      this.historyLoading = true;
      httpAction(api.historyInvoice, "post", obj).then(res => {
        this.data2.push(...res.data.infoList);
        this.pageInfo.totalCount = res.data.totalCount * 1;
        this.historyLoading = false;
        if (res.data.infoList.length < 10) {
          this.showMore = false;
        } else {
          if (pageNum > 1) this.showHidden = true;
          this.pageNum += 1;
        }
      });
    },
    // toEdit(params) {
    //   this.rowData = params.row;
    //   this.actionType = "update";
    //   this.$set(this.data1[params.index], "editable", true);
    // },
    toDetail(params) {
      console.log(params)
      this.title = '详细'
      this.actionType = "detail";
      this.addAndEditShow = true
      // this.rowData = params.row;
      this.formValidate.companyName = params.row.companyName
      this.formValidate.taxId = params.row.taxId
      this.formValidate.address = params.row.address
      this.formValidate.phone = params.row.phone
      this.formValidate.accountNo = params.row.accountNo
      this.formValidate.accountName = params.row.accountName
    },
    edit(params){
      this.title = '修改'
      this.actionType = "update";
      this.addAndEditShow = true
      // this.rowData = params.row;
      this.formValidate.companyName = params.row.companyName
      this.formValidate.taxId = params.row.taxId
      this.formValidate.address = params.row.address
      this.formValidate.phone = params.row.phone
      this.formValidate.accountNo = params.row.accountNo
      this.formValidate.accountName = params.row.accountName
      this.formValidate.id = params.row.id
    },
    // edit (params) {
    //   const data = params.row
    //   let companyNameContent = ''
    //   let taxIdContent = ''
    //   if (data.companyName === '') {
    //     companyNameContent = '请填写单位名称!'
    //   } else if (!isCompanyName(data.companyName)) {
    //     companyNameContent = '请填写正确的单位名称!'
    //   }
    //   // if (data.taxId === '') {
    //   //   taxIdContent = '请填写税号!'
    //   // } else if (!isCompanyName(data.taxId)) {
    //   //   taxIdContent = '请填写有效的税号!'
    //   // }
    //    if (data.taxId != '' && !isCompanyName(data.taxId)) {
    //     taxIdContent = '请填写有效的税号!'
    //   }
    //   if (companyNameContent) {
    //     this.$Message.warning({
    //       background: true,
    //       content: companyNameContent
    //     })
    //     return false
    //   } else if (taxIdContent) {
    //     this.$Message.warning({
    //       background: true,
    //       content: taxIdContent
    //     })
    //     return false
    //   }
    //   const obj = {
    //     companyName: data.companyName,
    //     taxId: data.taxId,
    //     isDefault: data.isDefault,
    //     type: 'company'
    //   }
    //   if (this.actionType === 'update') {
    //     obj.invoiceId = data.id
    //   }
    //   let url = this.actionType === 'update' ? api.updateInvoice : api.createInvoice
    //   httpAction(url, 'post', obj).then(res => {
    //     if (res) {
    //       this.getList()
    //       this.actionType = ''
    //       this.isEditing = false
    //     }
    //   })
    // },
    // add() {
    //   if (this.actionType !== "create") {
    //     this.actionType = "create";
    //     this.data1.push({
    //       companyName: "",
    //       taxId: "",
    //       isDefault: 0,
    //       type: 'company',
    //       editable: true
    //     });
    //   }
    // },
    add() {
      this.title = '新增'
      this.actionType = "create";
      this.addAndEditShow = true
    },
    remove() {
      this.modal_loading = true;
      const data = this.currentItem.row;
      const obj = {
        invoiceId: data.id
      };
      httpAction(api.deleteInvoice, "post", obj).then(res => {
        if (res) {
          this.cancel();
          this.modal_loading = false;
          this.getList();
          this.formInline =  {
            companyName: "",
            id: ""
          }
        }
      });
    },
    cancel() {
      this.deleteShow = false;
    }
  }
};
</script>

<style scoped>
.header-title-Invoice {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.space {
  padding: 10px;
}
.show-more-btn {
  display: inline-block;
  margin: 20px auto 0;
  box-shadow: none;
}
.next-btn {
  padding: 0 120px;
  height: 40px;
  margin-bottom: 20px;
}
.tab-btn {
  padding: 0 20px;
  margin-left: 20px;
}
.row-margin {
  margin-bottom: 20px;
}
</style>
